import * as IJEWEL from './diamond/index'
import Utils from './Utils'
import ProcessModel from './ProcessModel'
import * as THREE from 'three'
import PBRShaderMaterial from './PBRMaterial/PBRShaderMaterial'
// import { colorData } from '@editorController/colorData'
// import { colorData } from './colorData11'
import { colorData } from './colorData'
// import Loader from '@editorController/loader'
import Loader from './loaders/loader'
import * as materialConfig from './MaterialConfig.json'
import FileHelper from './FileHelper'
import Envirment from './Envirments/Envirment.js'
Array.prototype.remove = function(val) {
  var index = this.indexOf(val)
  if (index > -1) {
    this.splice(index, 1)
  }
}
class DiamondManager {
  constructor(viewPort) {
    this.renderer = viewPort.renderer
    this.viewPort = viewPort
    this.ydzMaterialConfig = {
      diamondEnvMapUrl: Utils.genCubeUrls(
        './static/asset_3d/Envirment/FourAreasStudio/',
        '.hdr'
      ),
    }
    this.fileHelper = new FileHelper()
    this.envirmentList = {}
    this.currentEnvirmentndex = 0
    this.currentEnvirment = this.Envirment = new Envirment()
    this.imageLoader = new THREE.ImageLoader()
    this.standerDiamondMaterial = null
    this.defaultDiamondMaterialType = 0
    this.defaultRingMaterialType = 0
    this.diamondConfig = {
      diamondsCubeTexture: null,
      diamonds: {
        heart: {
          modelPath: './static/asset_3d/model/diamond/heart.obj',
          imgMaterial: null,
          material: null,
          type: 'heart',
          mesh: null,
          uniform: {
            squashFactor: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].squashFactor,
            },
            normalOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].normalOffset,
            },
            rIndexDelta: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].rIndexDelta,
            },
            n2: {
              value: colorData.diamond[this.defaultDiamondMaterialType].n2,
            },
            distanceOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .distanceOffset,
            },
            envMapIntensity: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .envMapIntensity,
            },
            boostFactors: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].boostFactors.clone(),
            },
            colorCorrection: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].colorCorrection.clone(),
            },
            Absorbption: {
              value: new THREE.Vector3(0, 0, 0),
            },
          },
        },
        button: {
          modelPath: './static/asset_3d/model/diamond/button.obj',
          material: null,
          type: 'button',
          mesh: null,
          uniform: {
            squashFactor: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].squashFactor,
            },
            normalOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].normalOffset,
            },
            rIndexDelta: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].rIndexDelta,
            },
            n2: {
              value: colorData.diamond[this.defaultDiamondMaterialType].n2,
            },
            distanceOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .distanceOffset,
            },
            envMapIntensity: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .envMapIntensity,
            },
            boostFactors: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].boostFactors.clone(),
            },
            colorCorrection: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].colorCorrection.clone(),
            },
            Absorbption: {
              value: new THREE.Vector3(0, 0, 0),
            },
          },
        },
        moonpear: {
          modelPath: './static/asset_3d/model/diamond/moonpear.obj',
          material: null,
          type: 'moonpear',
          mesh: null,
          uniform: {
            squashFactor: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].squashFactor,
            },
            normalOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].normalOffset,
            },
            rIndexDelta: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].rIndexDelta,
            },
            n2: {
              value: colorData.diamond[this.defaultDiamondMaterialType].n2,
            },
            distanceOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .distanceOffset,
            },
            envMapIntensity: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .envMapIntensity,
            },
            boostFactors: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].boostFactors.clone(),
            },
            colorCorrection: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].colorCorrection.clone(),
            },
            Absorbption: {
              value: new THREE.Vector3(0, 0, 0),
            },
          },
        },
        rectDiamond: {
          modelPath: './static/asset_3d/model/diamond/rectDiamond.obj',
          material: null,
          type: 'rectDiamond',
          mesh: null,
          uniform: {
            squashFactor: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].squashFactor,
            },
            normalOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].normalOffset,
            },
            rIndexDelta: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].rIndexDelta,
            },
            n2: {
              value: colorData.diamond[this.defaultDiamondMaterialType].n2,
            },
            distanceOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .distanceOffset,
            },
            envMapIntensity: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .envMapIntensity,
            },
            boostFactors: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].boostFactors.clone(),
            },
            colorCorrection: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].colorCorrection.clone(),
            },
            Absorbption: {
              value: new THREE.Vector3(0, 0, 0),
            },
          },
        },
        wafercut: {
          modelPath: './static/asset_3d/model/diamond/wafercut.obj',
          material: null,
          type: 'wafercut',
          mesh: null,
          uniform: {
            squashFactor: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].squashFactor,
            },
            normalOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].normalOffset,
            },
            rIndexDelta: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].rIndexDelta,
            },
            n2: {
              value: colorData.diamond[this.defaultDiamondMaterialType].n2,
            },
            distanceOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .distanceOffset,
            },
            envMapIntensity: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .envMapIntensity,
            },
            boostFactors: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].boostFactors.clone(),
            },
            colorCorrection: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].colorCorrection.clone(),
            },
            Absorbption: {
              value: new THREE.Vector3(0, 0, 0),
            },
          },
        },
        diamond_1: {
          modelPath: './static/asset_3d/model/diamond/diamond_1.obj',
          material: null,
          type: 'diamond_1',
          mesh: null,
          uniform: {
            squashFactor: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].squashFactor,
            },
            normalOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].normalOffset,
            },
            rIndexDelta: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].rIndexDelta,
            },
            n2: {
              value: colorData.diamond[this.defaultDiamondMaterialType].n2,
            },
            distanceOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .distanceOffset,
            },
            envMapIntensity: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .envMapIntensity,
            },
            boostFactors: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].boostFactors.clone(),
            },
            colorCorrection: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].colorCorrection.clone(),
            },
            Absorbption: {
              value: new THREE.Vector3(0, 0, 0),
            },
          },
        },
        cushion: {
          modelPath: './static/asset_3d/model/diamond/cushion.obj',
          material: null,
          type: 'cushion',
          mesh: null,
          uniform: {
            squashFactor: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].squashFactor,
            },
            normalOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].normalOffset,
            },
            rIndexDelta: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].rIndexDelta,
            },
            n2: {
              value: colorData.diamond[this.defaultDiamondMaterialType].n2,
            },
            distanceOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .distanceOffset,
            },
            envMapIntensity: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .envMapIntensity,
            },
            boostFactors: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].boostFactors.clone(),
            },
            colorCorrection: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].colorCorrection.clone(),
            },
            Absorbption: {
              value: new THREE.Vector3(0, 0, 0),
            },
          },
        },
      },
    }
    this.initDiamondManager()
    // this.preProcess2()
  }
  async initDiamondManager() {
    await this.loadDiamondTexture()

    await this.loadEnvirmentByName('zz', materialConfig)
    await this.loadEnvirmentByName('JadeEnvirment1', materialConfig)
    await this.createDiamond('diamond_1')
    this.standerDiamondMaterial = this.diamondConfig.diamonds.diamond_1.material
  }
  preProcess2() {
    function n(e) {
      e.traverse(function(e) {
        if (e.isMesh) {
          ;(function(e) {
            var t = e.geometry
            if (!t.transformed) {
              l.set(0, 0, 0)
              var n = t.getAttribute('position').array,
                i = t.index
              if (i)
                for (var o = i.array, a = 0; a < o.length / 3; a += 3) {
                  var h = 3 * o[a],
                    f = 3 * o[a + 1],
                    p = 3 * o[a + 2]
                  s.set(n[h], n[h + 1], n[h + 2]),
                    u.set(n[f], n[f + 1], n[f + 2]),
                    c.set(n[p], n[p + 1], n[p + 2]),
                    u.sub(s),
                    c.sub(s),
                    c.cross(u),
                    l.add(c)
                }
              else
                for (var d = 0; d < n.length; d += 9)
                  s.set(n[d], n[d + 1], n[d + 2]),
                    u.set(n[d + 3], n[d + 4], n[d + 5]),
                    c.set(n[d + 6], n[d + 7], n[d + 8]),
                    u.sub(s),
                    c.sub(s),
                    c.cross(u),
                    c.normalize(),
                    l.add(c)
              l.normalize(), t.computeBoundingBox(), t.computeBoundingSphere()
              var m = new THREE.Matrix4()
              m.identity()
              var g = t.boundingSphere.center
              m.makeTranslation(g.x, g.y, g.z), t.center()
              for (var v = !1, y = 0; !v; ) {
                s.set(n[y], n[y + 1], n[y + 2]), s.normalize()
                var b = l.dot(s)
                Math.abs(b - 1) > 0.001 && (v = !0), (y += 3)
              }
              u.crossVectors(s, l),
                u.normalize(),
                l.dot(u),
                s.crossVectors(l, u),
                s.normalize(),
                l.dot(s),
                u.dot(s)
              var x = new THREE.Matrix4()
              ;(x.elements[0] = s.x),
                (x.elements[1] = s.y),
                (x.elements[2] = s.z),
                (x.elements[3] = 0),
                (x.elements[4] = l.x),
                (x.elements[5] = l.y),
                (x.elements[6] = l.z),
                (x.elements[7] = 0),
                (x.elements[8] = u.x),
                (x.elements[9] = u.y),
                (x.elements[10] = u.z),
                (x.elements[11] = 0),
                (x.elements[12] = 0),
                (x.elements[13] = 0),
                (x.elements[14] = 0),
                (x.elements[15] = 1)
              var w = new THREE.Matrix4()
              // w.getInverse(x), 
              w.copy(x).invert()
              t.applyMatrix(w), t.computeBoundingSphere()
              var _ = t.boundingSphere.radius,
                A = new THREE.Matrix4()
              A.identity(), A.makeScale(_, _, _)
              var M = new THREE.Matrix4()
              // M.getInverse(A),
              M.copy(A).invert()

             t.applyMatrix(M), x.multiply(A), m.multiply(x)
              var T = new THREE.Matrix4()
              T.compose(e.position, e.quaternion, e.scale), T.multiply(m)
              var S = new THREE.Vector3(),
                k = new THREE.Quaternion(),
                E = new THREE.Vector3()
              T.decompose(S, k, E),
                e.position.copy(S),
                e.quaternion.copy(k),
                e.scale.copy(E),
                (t.transformed = !0)
            }
          })(e)
        }
      })
    }

    var s = new THREE.Vector3(),
      u = new THREE.Vector3(),
      c = new THREE.Vector3(),
      l = new THREE.Vector3()
    ;(DiamondManager.DiamondUtils = {}),
      (DiamondManager.DiamondUtils.prototypeMaterials = [])
    DiamondManager.DiamondUtils.processScene = function(e) {
      //  debugger
      n(e)
    }
  }

  //加载钻石需要的cubeMap
  loadDiamondTexture() {
    return new Promise((resolve, reject) => {
      Promise.all([
        Loader.loadCubeHDREnvirment(
          this.ydzMaterialConfig.diamondEnvMapUrl,
          this.renderer
        ),
      ]).then((diamondEnvirmentMap) => {
        this.diamondEnvirmentMap = diamondEnvirmentMap[0]
        resolve()
      })
    })
  }
  loadEnvirmentByName(envirmentName, config) {
    if (!config.default[envirmentName]) {
      return
    }
    if (this.envirmentList[envirmentName]) {
      return new Promise((resolve, reject) => {
        resolve(this.envirmentList[envirmentName])
      })
    } else {
      let _Envirment = new Envirment()
      this.envirmentList[envirmentName] = _Envirment
      let envirmentConfig = config.default[envirmentName]
      let mapSrc = envirmentConfig.envirment.panoramaCube
      return new Promise((resolve) => {
        Promise.all([
          this.fileHelper.requestResource(mapSrc),
          this.fileHelper.requestResource(envirmentConfig.envirment.config),
        ]).then(([envMap, config]) => {
          let fileMap = null
          let path = envirmentConfig.envirment.envPath
          fileMap = {
            'specular_panorama_ue4_1024_luv.bin.gz': envMap,
            'config.json': config,
          }
          _Envirment.readZipContent(fileMap, path, false).then(() => {
            resolve(_Envirment)
          })
        })
      })
    }
  }
  createDiamond(type, addscene) {
    return new Promise((resolve, reject) => {
      let diamond = this.diamondConfig.diamonds[type]
      if (!diamond.mesh) {
        ProcessModel.loadModel({
          model: {
            path: diamond.modelPath,
            type: 'obj',
          },
        }).then((object) => {
          object.traverse((child) => {
            if (child.isMesh) {
              diamond.mesh = child
            }
          })
          this.createNewDiamondMaterial(diamond.mesh, type)
          if (addscene) this.viewPort.editor.addObjectCommand(diamond.mesh)
          resolve(diamond.mesh)
        })
      } else {
        resolve(diamond.mesh)
      }
    })
  }
  createDiamondByMaterial(mesh, material) {
    let diamond = new IJEWEL.Diamond(mesh, material)
    return diamond
  }
  createNewDiamondMaterial(mesh, type) {
    if (
      !this.diamondConfig.diamonds[type] ||
      !this.diamondConfig.diamonds[type].material
    ) {
      let material = new IJEWEL.DiamondMaterial(
        mesh,
        this.diamondEnvirmentMap,
        this.renderer
      )
      new IJEWEL.Diamond(mesh, material)
      if (type) {
        mesh.material.userData.diamondType = type
        this.diamondConfig.diamonds[type] = {
          material: material,
          type: type,
          mesh: mesh,
          uniform: {
            squashFactor: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].squashFactor,
            },
            normalOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].normalOffset,
            },
            rIndexDelta: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType].rIndexDelta,
            },
            n2: {
              value: colorData.diamond[this.defaultDiamondMaterialType].n2,
            },
            distanceOffset: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .distanceOffset,
            },
            envMapIntensity: {
              value:
                colorData.diamond[this.defaultDiamondMaterialType]
                  .envMapIntensity,
            },
            boostFactors: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].boostFactors.clone(),
            },
            colorCorrection: {
              value: colorData.diamond[
                this.defaultDiamondMaterialType
              ].colorCorrection.clone(),
            },
            Absorbption: {
              value: new THREE.Vector3(0, 0, 0),
            },
          },
        }
      }
    } else {
      new IJEWEL.Diamond(mesh, this.diamondConfig.diamonds[type].material)
    }

    return mesh
  }
  processDiamondCustomRing(ringMesh, type) {
    // 默认金属银
    let defaultmaterial =
      colorData.RingMConfig.materials[
        type === undefined ? this.defaultRingMaterialType : type
      ]
    let newPhysicalMaterial = new PBRShaderMaterial()
    if(defaultmaterial.alphaMapTransform){
      newPhysicalMaterial.alphaMapTransform.fromArray(
        defaultmaterial.alphaMapTransform
      )
    }
  
    newPhysicalMaterial.alphaMap_uv = defaultmaterial.alphaMap_uv
    newPhysicalMaterial.aoMapIntensity = defaultmaterial.aoMapIntensity
    newPhysicalMaterial.aoMapTransform.fromArray(defaultmaterial.aoMapTransform)
    newPhysicalMaterial.aoMap_uv = defaultmaterial.aoMap_uv
    newPhysicalMaterial.bumpMapTransform.fromArray(
      defaultmaterial.bumpMapTransform
    )
    newPhysicalMaterial.bumpMap_uv = defaultmaterial.bumpMap_uv
    newPhysicalMaterial.bumpScale = defaultmaterial.bumpScale
    newPhysicalMaterial.diffuse.fromArray(defaultmaterial.diffuse)
    newPhysicalMaterial.emissive.fromArray(defaultmaterial.emissive)
    newPhysicalMaterial.emissiveIntensity = defaultmaterial.emissiveIntensity
    newPhysicalMaterial.emissiveMapTransform.fromArray(
      defaultmaterial.emissiveMapTransform
    )
    newPhysicalMaterial.emissiveMap_uv = defaultmaterial.emissiveMap_uv
    newPhysicalMaterial.envMapIntensity = defaultmaterial.envMapIntensity
    newPhysicalMaterial.lightMapIntensity = defaultmaterial.lightMapIntensity
    newPhysicalMaterial.lightMapTransform.fromArray(
      defaultmaterial.lightMapTransform
    )
    newPhysicalMaterial.lightMap_uv = defaultmaterial.lightMap_uv
    newPhysicalMaterial.mapTransform.fromArray(defaultmaterial.mapTransform)
    newPhysicalMaterial.map_uv = defaultmaterial.map_uv
    newPhysicalMaterial.metalness = defaultmaterial.metalness
    newPhysicalMaterial.metalnessMapTransform.fromArray(
      defaultmaterial.metalnessMapTransform
    )
    newPhysicalMaterial.metalnessMap_uv = defaultmaterial.metalnessMap_uv
    // newPhysicalMaterial.name = defaultmaterial.name;
    newPhysicalMaterial.normalMapTransform.fromArray(
      defaultmaterial.normalMapTransform
    )
    newPhysicalMaterial.normalMap_uv = defaultmaterial.normalMap_uv
    newPhysicalMaterial.normalScale.fromArray(defaultmaterial.normalScale)
    newPhysicalMaterial.opacity = defaultmaterial.opacity
    newPhysicalMaterial.roughness = defaultmaterial.roughness
    newPhysicalMaterial.roughnessMapTransform.fromArray(
      defaultmaterial.roughnessMapTransform
    )
    newPhysicalMaterial.roughnessMap_uv = defaultmaterial.roughnessMap_uv
    newPhysicalMaterial.uAOPBROccludeSpecular =
      defaultmaterial.uAOPBROccludeSpecular
    newPhysicalMaterial.uClearCoatF0 = defaultmaterial.uClearCoatF0
    newPhysicalMaterial.uClearCoatFactor = defaultmaterial.uClearCoatFactor
    newPhysicalMaterial.uClearCoatIor = defaultmaterial.uClearCoatIor
    newPhysicalMaterial.uClearCoatRoughnessFactor =
      defaultmaterial.uClearCoatRoughnessFactor
    newPhysicalMaterial.uClearCoatThickness =
      defaultmaterial.uClearCoatThickness
    newPhysicalMaterial.uClearCoatTint.fromArray(defaultmaterial.uClearCoatTint)
    newPhysicalMaterial.uDrawOpaque = defaultmaterial.uDrawOpaque
    newPhysicalMaterial.uEmitMultiplicative =
      defaultmaterial.uEmitMultiplicative
    newPhysicalMaterial.uEnvironmentTransform.fromArray(
      defaultmaterial.uEnvironmentTransform
    )
    newPhysicalMaterial.uMultiplyLightMap = defaultmaterial.uMultiplyLightMap
    newPhysicalMaterial.uNormalMapFactor = defaultmaterial.uNormalMapFactor
    newPhysicalMaterial.uNormalMapFlipY = defaultmaterial.uNormalMapFlipY
    newPhysicalMaterial.uSpecularF0Factor = defaultmaterial.uSpecularF0Factor
    newPhysicalMaterial.uSpecularPeak = defaultmaterial.uSpecularPeak
    newPhysicalMaterial.useClearCoat = defaultmaterial.useClearCoat
    newPhysicalMaterial.translucency_uv = defaultmaterial.translucency_uv
    newPhysicalMaterial.uSubsurfaceTranslucencyThicknessFactor =
      defaultmaterial.uSubsurfaceTranslucencyThicknessFactor
    newPhysicalMaterial.uSubsurfaceTranslucencyFactor =
      defaultmaterial.uSubsurfaceTranslucencyFactor
    newPhysicalMaterial.uSubsurfaceTranslucencyColor.fromArray(
      defaultmaterial.uSubsurfaceTranslucencyColor
    )

    newPhysicalMaterial.userData = ringMesh.material.userData
    newPhysicalMaterial.name = ringMesh.material.name
    ringMesh.material = newPhysicalMaterial
    ringMesh.material.needsUpdate = true
    this.viewPort.useEnvirmentMap(ringMesh)
  }
  applyDiamondUniforms(
    diamondPrototype,
    {
      squashFactor,
      normalOffset,
      rIndexDelta,
      n2,
      distanceOffset,
      envMapIntensity,
      boostFactors,
      colorCorrection,
      Absorbption,
      diamondColorCorrection,
      centreOffset,
    }
  ) {
    diamondPrototype.uniforms['squashFactor'].value = squashFactor.value
    diamondPrototype.uniforms['normalOffset'].value = normalOffset.value
    diamondPrototype.uniforms['rIndexDelta'].value = rIndexDelta.value
    diamondPrototype.uniforms['n2'].value = n2.value
    diamondPrototype.uniforms['distanceOffset'].value = distanceOffset.value
    diamondPrototype.uniforms['envMapIntensity'].value = envMapIntensity.value
    diamondPrototype.uniforms['boostFactors'].value.set(
      boostFactors.value.x,
      boostFactors.value.y,
      boostFactors.value.z
    )
    // if( centreOffset){
    //     diamondPrototype.uniforms['centreOffset'].value.set(
    //         centreOffset.value.x,
    //         centreOffset.value.y,
    //         centreOffset.value.z
    //     );
    // }

    diamondPrototype.uniforms['colorCorrection'].value.set(
      colorCorrection.value.x,
      colorCorrection.value.y,
      colorCorrection.value.z
    )
    // diamondPrototype.uniforms['Absorbption'].value.set(
    //     Absorbption.value.x,
    //     Absorbption.value.y,
    //     Absorbption.value.z
    // );
    if (diamondColorCorrection) {
      diamondPrototype.uniforms['diamondColorCorrection'].value.set(
        diamondColorCorrection.value.x,
        diamondColorCorrection.value.y,
        diamondColorCorrection.value.z
      )
    }

    diamondPrototype.needsUpdate = true
  }
  checkDiamondAndRing(object) {
    if (!object.material.isDiamondMaterial) {
    }
  }
  ensureDiamondCustomScene(data) {
    if (data.isObject3D) {
      let box3 = new THREE.Box3()
      box3.expandByObject(data)
      let mainDiamond = (this.mainDiamond = [])
      let dsmDiamond = []

      data.traverse(async (child) => {
        if (child.isObject3D) {
          child.updateMatrixWorld(true)
        }
        if (!child.isMesh) return

        if (child.material.name) {
          child.material.name = child.material.name.toLowerCase()
        }
        let materialName = child.material.name || '新材质'
        if (child.userData._materialName) {
          materialName = child.userData._materialName.toLowerCase()
        }

        if (materialName.includes('d_mm')) {
          mainDiamond.push(child)
        } else if (materialName.includes('d_sm')) {
          // 钻石
          dsmDiamond.push(child)
        } else if (materialName.includes('ringm')) {
          // 戒臂
          this.processDiamondCustomRing(child, child.userData._MaterialType)
        } else if (child.userData && child.userData.isJade) {
          let materialType =
            child.userData._MaterialType ||
            child.userData.jadeMaterialType ||
            'FC'
          await this.processPBRMaterialFromServerData(
            materialConfig.Jade[materialType],
            child.material
          )
          child.needsSSS = true
          this.setJadeMaterialEnvirment(child.material)
          if (materialConfig.Jade[materialType].useSSS)
            child.material.userData.isJade = true
          child.material.needsUpdate = true
        } else if (materialName.includes('d_j')) {
        } else if (materialName.includes('d_p')) {
          let zzEnvirment = await this.loadEnvirmentByName('zz', materialConfig)
          let _pearlMaterial = new PBRShaderMaterial()
          await this.processPBRMaterialFromServerData(
            materialConfig.zz.material,
            _pearlMaterial
          )
          child.material.userData.isPearl = true
          child.needsSSS = true
          child.material = _pearlMaterial
          // this.viewPort.useEnvirmentMap(child.material)
          child.material.uEnvironmentExposure =
            materialConfig.zz.envirmentBrightNess
          child.material.uEnvironmentTransform.makeRotationY(
            materialConfig.zz.envirmentRotation
          )
          this.useEnvirmentMap(child.material, zzEnvirment)
          this.viewPort.useSSSPostProcess(child, true)
          child.material.needsUpdate = true
        }
      })
      mainDiamond.forEach((item) => {
        let materialName = item.material.name || '新材质'
        if (item.userData._materialName) {
          materialName = item.userData._materialName.toLowerCase()
        }
        if (item.isMesh) {
          this.createNewDiamondMaterial(item, Math.random())
          item.material.name = materialName
          if (item.userData.isGem && item.userData.uniforms !== undefined) {
            this.applyDiamondUniforms(item.material, item.userData.uniforms)
          } else {
            this.changeDiamondMaterialByStander(
              this.defaultDiamondMaterialType,
              item
            )
          }
        }
      })
      let firstDsmDiamondType = 'd_sm'
      dsmDiamond.forEach((item) => {
        let materialName = item.material.name || '新材质'
        if (item.userData._materialName) {
          materialName = item.userData._materialName.toLowerCase()
        }
        if (!this.firstDsmDiamondMaterial) {
          this.createNewDiamondMaterial(item, firstDsmDiamondType)
          this.firstDsmDiamondMaterial = this.diamondConfig.diamonds[
            firstDsmDiamondType
          ].material
        }
        if (item.isMesh) {
          this.createDiamondByMaterial(item, this.firstDsmDiamondMaterial)
          item.material.name = materialName

          if (item.userData.isGem && item.userData.uniforms !== undefined) {
            this.applyDiamondUniforms(item.material, item.userData.uniforms)
          } else {
            this.changeDiamondMaterialByStander(
              this.defaultDiamondMaterialType,
              item
            )
          }
        }
      })

      if (
        Math.abs(box3.max.x < 0.1) ||
        Math.abs(box3.max.y) < 0.1 ||
        Math.abs(box3.max.z) < 0.1
      ) {
        let root = data.getObjectByName('root')
        if (root) {
          root.position.y = 10
        }
      }
      return {
        mainDiamond,
        dsmDiamond,
      }
    }
  }

  async setJadeMaterialEnvirment(material) {
    let jadeEnvirment = await this.loadEnvirmentByName(
      'JadeEnvirment1',
      materialConfig
    )
    material.uEnvironmentExposure =
      materialConfig.JadeEnvirment1.envirmentBrightNess
    material.uEnvironmentTransform.makeRotationY(
      materialConfig.JadeEnvirment1.envirmentRotation
    )
    this.useEnvirmentMap(material, jadeEnvirment)
    material.userData.isJade = true
  }
  //支持mesh，和material作为参数传入
  //支持mesh，和material作为参数传入
  useEnvirmentMap(material, envirment) {
    // mesh.material.envMap = this.Envirment._cubemapUE4['LUV'].cubeMap;

    let currentEnvirment = envirment
    material.envMap = currentEnvirment._panoramaUE4['LUV'].envMap
    material.uTextureEnvironmentSpecularPBRLodRange.set(
      currentEnvirment._panoramaUE4.nbLod,
      currentEnvirment._panoramaUE4.maxLod
    )
    material.defines['PANORAMA_ENVIRMENT'] = ''
    material.uTextureEnvironmentSpecularPBRTextureSize.set(1024, 1024)

    material.envMap.needsUpdate = true
    material.uDiffuseSPH = currentEnvirment._spherical.sphCoef
    // mesh.material.sIntegrateBRDF = this.Envirment._integrateBRDF.brdfTexture;
    material.needsUpdate = true
  }
  async processPBRMaterialFromServerData(data, pbrMaterial) {
    pbrMaterial.anisotropy = data.anisotropy
    pbrMaterial.uAnisotropyDirection = data.uAnisotropyDirection
    pbrMaterial.uAnisotropyFactor = data.uAnisotropyFactor

    pbrMaterial.alphaMapTransform.fromArray(data.alphaMapTransform)
    pbrMaterial.alphaMap_uv = data.alphaMap_uv
    pbrMaterial.aoMapIntensity = data.aoMapIntensity
    pbrMaterial.aoMapTransform.fromArray(data.aoMapTransform)
    pbrMaterial.aoMap_uv = data.aoMap_uv
    pbrMaterial.bumpMapTransform.fromArray(data.bumpMapTransform)
    pbrMaterial.bumpMap_uv = data.bumpMap_uv
    pbrMaterial.bumpScale = data.bumpScale
    pbrMaterial.diffuse.fromArray(data.diffuse)
    pbrMaterial.emissive.fromArray(data.emissive)
    pbrMaterial.emissiveIntensity = data.emissiveIntensity
    pbrMaterial.emissiveMapTransform.fromArray(data.emissiveMapTransform)
    pbrMaterial.emissiveMap_uv = data.emissiveMap_uv
    pbrMaterial.envMapIntensity = data.envMapIntensity
    pbrMaterial.lightMapIntensity = data.lightMapIntensity
    pbrMaterial.lightMapTransform.fromArray(data.lightMapTransform)
    pbrMaterial.lightMap_uv = data.lightMap_uv
    pbrMaterial.mapTransform.fromArray(data.mapTransform)
    pbrMaterial.map_uv = data.map_uv
    pbrMaterial.metalness = data.metalness
    pbrMaterial.metalnessMapTransform.fromArray(data.metalnessMapTransform)
    pbrMaterial.metalnessMap_uv = data.metalnessMap_uv
    pbrMaterial.name = data.name
    pbrMaterial.normalMapTransform.fromArray(data.normalMapTransform)
    pbrMaterial.normalMap_uv = data.normalMap_uv
    pbrMaterial.normalScale.fromArray(data.normalScale)
    pbrMaterial.opacity = data.opacity
    pbrMaterial.roughness = data.roughness
    pbrMaterial.roughnessMapTransform.fromArray(data.roughnessMapTransform)
    pbrMaterial.roughnessMap_uv = data.roughnessMap_uv
    pbrMaterial.uAOPBROccludeSpecular = data.uAOPBROccludeSpecular
    pbrMaterial.uClearCoatF0 = data.uClearCoatF0
    pbrMaterial.uClearCoatFactor = data.uClearCoatFactor
    pbrMaterial.uClearCoatIor = data.uClearCoatIor
    pbrMaterial.uClearCoatRoughnessFactor = data.uClearCoatRoughnessFactor
    pbrMaterial.uClearCoatThickness = data.uClearCoatThickness
    pbrMaterial.uClearCoatTint.fromArray(data.uClearCoatTint)
    pbrMaterial.uDrawOpaque = data.uDrawOpaque
    pbrMaterial.uEmitMultiplicative = data.uEmitMultiplicative
    pbrMaterial.uEnvironmentTransform.fromArray(data.uEnvironmentTransform)
    pbrMaterial.uMultiplyLightMap = data.uMultiplyLightMap
    pbrMaterial.uNormalMapFactor = data.uNormalMapFactor
    pbrMaterial.uNormalMapFlipY = data.uNormalMapFlipY
    pbrMaterial.uSpecularF0Factor = data.uSpecularF0Factor
    pbrMaterial.uSpecularPeak = data.uSpecularPeak
    pbrMaterial.useClearCoat = data.useClearCoat
    pbrMaterial.translucency_uv = data.translucency_uv
    pbrMaterial.uSubsurfaceTranslucencyThicknessFactor =
      data.uSubsurfaceTranslucencyThicknessFactor
    pbrMaterial.uSubsurfaceTranslucencyFactor =
      data.uSubsurfaceTranslucencyFactor
    pbrMaterial.uSubsurfaceTranslucencyColor.fromArray(
      data.uSubsurfaceTranslucencyColor
    )
    if (data.translucencyMapTransform)
      pbrMaterial.translucencyMapTransform.fromArray(
        data.translucencyMapTransform
      )

    await this.processServerTexture(data.map, pbrMaterial, 'map')
    await this.processServerTexture(data.alphaMap, pbrMaterial, 'alphaMap')
    await this.processServerTexture(
      data.metalnessMap,
      pbrMaterial,
      'metalnessMap'
    )
    await this.processServerTexture(
      data.emissiveMap,
      pbrMaterial,
      'emissiveMap'
    )
    await this.processServerTexture(
      data.roughnessMap,
      pbrMaterial,
      'roughnessMap'
    )
    await this.processServerTexture(data.normalMap, pbrMaterial, 'normalMap')
    await this.processServerTexture(data.bumpMap, pbrMaterial, 'bumpMap')
    await this.processServerTexture(data.lightMap, pbrMaterial, 'lightMap')
    await this.processServerTexture(
      data.translucencyMap,
      pbrMaterial,
      'translucencyMap'
    )
  }
  processServerTexture(texture, pbrMaterial, name) {
    if (!texture) {
      return
    }

    let resourceUrl = texture.imageData.imageObject.imageSrc
    let texture0 = new THREE.Texture()
    texture0.magFilter = texture.magFilter
    texture0.minFilter = texture.minFilter
    texture0.name = texture.name
    texture0.offset.fromArray(texture.offset)
    texture0.repeat.fromArray(texture.repeat)
    texture0.rotation = texture.rotation
    texture0.wrapS = texture.wrapS
    texture0.wrapT = texture.wrapT
    texture0.format = texture.format
    texture0.flipY = texture.flipY
    texture0.encoding = texture.encoding
    texture0.center.fromArray(texture.center)

    this.imageLoader.setCrossOrigin('anonymous')
    return new Promise((resolve, reject) => {
      this.imageLoader.load(resourceUrl, function(image) {
        texture0.image = image
        texture0.needsUpdate = true
        pbrMaterial[name] = texture0
        resolve(pbrMaterial)
      })
    })
  }
  changeDiamondMaterialByStander(type, gemObject) {
    if (gemObject.isMesh && gemObject.userData.isGem) {
      gemObject.userData.GemMaterialType = type
      let data = colorData.diamond[type]
      gemObject.material.uniforms['diamondColorCorrection'].value.set(
        data.colorRGBIntencity,
        data.colorRGBIntencity,
        data.colorRGBIntencity
      )
      let uniforms = {
        squashFactor: {
          value: data.squashFactor,
        },
        normalOffset: {
          value: data.normalOffset,
        },
        rIndexDelta: {
          value: data.rIndexDelta,
        },
        n2: {
          value: data.n2,
        },
        distanceOffset: {
          value: data.distanceOffset,
        },
        envMapIntensity: {
          value: data.envMapIntensity,
        },
        boostFactors: {
          value: data.boostFactors,
        },
        colorCorrection: {
          value: data.colorCorrection,
        },
        Absorbption: {
          value: new THREE.Vector3(),
        },
        // centreOffset:{
        //     value: data.centreOffset ||new THREE.Vector3() ,
        // }
      }
      this.applyDiamondUniforms(gemObject.material, uniforms)
    }
  }
  processDiamond(object) {}
}
export default DiamondManager
